/**
 * Shared download/export utilities.
 * Extracted from SchemaDraftWorkspace.
 */

export const downloadBlob = (content: string, filename: string, mimeType: string): void => {
  if (typeof document === 'undefined') {
    return;
  }
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 500);
};

export const toCsv = (rows: string[][]): string =>
  rows
    .map((row) =>
      row
        .map((value) => {
          const stringValue = value ?? '';
          if (stringValue.includes('"') || stringValue.includes(',') || stringValue.includes('\n')) {
            return `"${stringValue.replace(/"/g, '""')}"`;
          }
          return stringValue;
        })
        .join(',')
    )
    .join('\n');
